import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { allDownloadStatistics} from '../../api'
  
 
  
export default /*#__PURE__*/_defineComponent({
  __name: 'userDownloads',
  setup(__props) {

  const searchSelection = ref("")
  const typeStr = ref("0")
  
  const loading = ref(false);
  
  const dataSource = ref([]);
  
  const selectedKeys = ref([]); 
  
  const page = reactive({ current: 1, limit: 10, total: 0 });

  const search = reactive({
    key: searchSelection,
    type: typeStr
  })
  
  const columns = ref([
    // { title: "id", key: "id", align: "center" }, 
    { title: "代理账号", key: "userName", align: "center" }, 
    { title: "设备码", key: "deviceId", align: "center"},
    // { title: "请求头", key: "userAgent", align: "center" }, 
    { title: "ip", key: "ip", align: "center" }, 
    { title: "说明", key: "state", align: "center", customSlot: "state" },  
    { title: "时间", key: "addTime", align: "center" }, 
  ]);
  
  const getAllDownloadStatistics = () => {
    loading.value = true;
    var data = { "page": page.current, "limit": page.limit, "key": search.key ,"type":search.type};
    allDownloadStatistics(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllDownloadStatistics();
  
  const change = (page: any) => {
    getAllDownloadStatistics();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
   
  //查询接口
  const searchUser = () => {
    page.current=1;
    getAllDownloadStatistics();
  }
    
 
  
return (_ctx: any,_cache: any) => {
  const _component_space = _resolveComponent("space")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!

  return (_openBlock(), _createBlock(_component_lay_row, { space: "10" }, {
    default: _withCtx(() => [
      _createVNode(_component_lay_col, { md: "24" }, {
        default: _withCtx(() => [
          _createVNode(_component_lay_panel, null, {
            default: _withCtx(() => [
              _createVNode(_component_lay_table, {
                page: page,
                height: '100%',
                columns: columns.value,
                loading: loading.value,
                "data-source": dataSource.value,
                "selected-keys": selectedKeys.value,
                "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((selectedKeys).value = $event)),
                onChange: change,
                onSortChange: sortChange
              }, {
                state: _withCtx(({ row }) => [
                  (row.state==0)
                    ? (_openBlock(), _createBlock(_component_space, { key: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 正常 ")
                        ]),
                        _: 1
                      }))
                    : (row.state==1)
                      ? (_openBlock(), _createBlock(_component_space, { key: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 指纹重复 ")
                          ]),
                          _: 1
                        }))
                      : (row.state==2)
                        ? (_openBlock(), _createBlock(_component_space, { key: 2 }, {
                            default: _withCtx(() => [
                              _createTextVNode(" ip重复 ")
                            ]),
                            _: 1
                          }))
                        : (row.state==3)
                          ? (_openBlock(), _createBlock(_component_space, { key: 3 }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 请求头部重复 ")
                              ]),
                              _: 1
                            }))
                          : (row.state==4)
                            ? (_openBlock(), _createBlock(_component_space, { key: 4 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 设备重复 ")
                                ]),
                                _: 1
                              }))
                            : (row.state==5)
                              ? (_openBlock(), _createBlock(_component_space, { key: 5 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 老用户 ")
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_space, { key: 6 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 其他 ")
                                  ]),
                                  _: 1
                                }))
                ]),
                _: 1
              }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})